import { render, staticRenderFns } from "./appraisalQuestionBankInformation.vue?vue&type=template&id=9252d15e"
import script from "./appraisalQuestionBankInformation.vue?vue&type=script&lang=js"
export * from "./appraisalQuestionBankInformation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports